import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AppSettings } from "../../config/app-settings.js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../app/auth/authSlice.js";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import showErrorToast, { showSuccessToast } from "../../components/CustomComponents/toast/toast.js";
import APIs from "../../Constants/apis.js";
import FloatingPasswordInput from "../../components/CustomComponents/Input/FloatingPasswordInput.jsx";

function Login() {
  const context = useContext(AppSettings);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [keepMeLogin, setKeepMeLogin] = useState(false);
  const [loading, setLoading] = useState(false);


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeBg, setActiveBg] = useState(
    "/assets/img/login-bg/login-bg-17.jpg"
  );
  const [bg1, setBg1] = useState(true);
  const [bg2, setBg2] = useState(false);
  const [bg3, setBg3] = useState(false);
  const [bg4, setBg4] = useState(false);
  const [bg5, setBg5] = useState(false);
  const [bg6, setBg6] = useState(false);
  const selectBg = (e, active, bg) => {
    e.preventDefault();

    setActiveBg(bg);
    setBg1(active === "bg1");
    setBg2(active === "bg2");
    setBg3(active === "bg3");
    setBg4(active === "bg4");
    setBg5(active === "bg5");
    setBg6(active === "bg6");
  };

  const validateForm = () => {
    let valid = true;
    let errors = { userName: "", password: "" };

    if (!userName.trim()) {
      errors.userName = "Username is required";
      valid = false;
    }
    if (!password.trim()) {
      errors.password = "Password is required";
      valid = false;
    }

    if (!valid) {
      showErrorToast(errors.userName || errors.password);
    }

    return valid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      await axiosInstance.get(APIs.LOGIN, {
        params: {
          userName,
          password
        }
      }).then(response => {
        if (response.status === 200 && response.data.status) {
          const userData = {
            token: response.data.data.token,
            userData: response.data.data.userData,
            refreshToken: response.data.data.refreshToken,
            keepMeLogin: keepMeLogin,
          };

          // Store refresh token separately for easy access
          if (response.data.data.refreshToken) {
            sessionStorage.setItem('refreshToken', response.data.data.refreshToken);
          }

          // Store keepMeLogin preference in localStorage (preference shared across tabs)
          if (keepMeLogin) {
            localStorage.setItem('keepMeLogin', JSON.stringify(keepMeLogin));
          }

          dispatch(login(userData));
          setLoading(false);
          showSuccessToast('Logged in Successfully.');
          navigate("/dashboard");
        } else {
          showErrorToast(response.data.message || 'Login failed');
          setLoading(false);
        }
      });


    } catch (err) {
      showErrorToast(err?.response?.data?.message ?? "Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return function cleanUp() {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
  }, []);

  return (

    <div>
      {loading && (<Preloader />)}

      <div className="login login-v2 fw-bold">
        <div className="login-cover">
          <div
            className="login-cover-img"
            style={{ backgroundImage: `url(${activeBg})` }}
          ></div>
          <div className="login-cover-bg"></div>
        </div>

        <div className="login-container">

          <div className="login-content">
            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-20px">
                <input
                  type="text"
                  value={userName}
                  className="form-control fs-13px h-45px border-0"
                  placeholder="User Name"
                  onChange={(e) => setUserName(e.target.value)}
                  id="userName"
                />
                <label
                  htmlFor="userName"
                  className="d-flex align-items-center text-gray-600 fs-13px"
                >
                  User Name
                </label>
              </div>
              <FloatingPasswordInput
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="form-check mb-20px">
                <input
                  className="form-check-input border-0"
                  type="checkbox"
                  checked={keepMeLogin}
                  onChange={(e) => setKeepMeLogin(e.target.checked)}
                  id="rememberMe"
                />
                <label
                  className="form-check-label fs-13px text-gray-500"
                  htmlFor="rememberMe"
                >
                  Remember Me
                </label>
              </div>
              <div className="mb-20px">
                <button
                  type="submit"
                  className="btn btn-theme d-block w-100 h-45px btn-lg"
                >
                  Sign me in
                </button>
              </div>
              <div className="mb-20px text-center">
                <Link className="text-theme">
                  Forget Password?
                </Link>
              </div>
              <hr className="bg-gray-600 opacity-2" />
              <div className="text-gray-600 text-center text-gray-500-darker mb-0">
                &copy; ALTEPOS All Right Reserved 2026
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="login-bg-list clearfix">
        <div className={`login-bg-list-item ${bg1 ? 'active' : ''}`}>
          <Link to="/user/login-v2" onClick={(e) => selectBg(e, 'bg1', '/assets/img/login-bg/login-bg-17.jpg')} style={{ backgroundImage: 'url(/assets/img/login-bg/login-bg-17.jpg)' }} className="login-bg-list-link"></Link>
        </div>
        <div className={`login-bg-list-item ${bg2 ? 'active' : ''}`}>
          <Link to="/user/login-v2" onClick={(e) => selectBg(e, 'bg2', '/assets/img/login-bg/login-bg-16.jpg')} style={{ backgroundImage: 'url(/assets/img/login-bg/login-bg-16.jpg)' }} className="login-bg-list-link"></Link>
        </div>
        <div className={`login-bg-list-item ${bg3 ? 'active' : ''}`}>
          <Link to="/user/login-v2" onClick={(e) => selectBg(e, 'bg3', '/assets/img/login-bg/login-bg-15.jpg')} style={{ backgroundImage: 'url(/assets/img/login-bg/login-bg-15.jpg)' }} className="login-bg-list-link"></Link>
        </div>
        <div className={`login-bg-list-item ${bg4 ? 'active' : ''}`}>
          <Link to="/user/login-v2" onClick={(e) => selectBg(e, 'bg4', '/assets/img/login-bg/login-bg-14.jpg')} style={{ backgroundImage: 'url(/assets/img/login-bg/login-bg-14.jpg)' }} className="login-bg-list-link"></Link>
        </div>
        <div className={`login-bg-list-item ${bg5 ? 'active' : ''}`}>
          <Link to="/user/login-v2" onClick={(e) => selectBg(e, 'bg5', '/assets/img/login-bg/login-bg-13.jpg')} style={{ backgroundImage: 'url(/assets/img/login-bg/login-bg-13.jpg)' }} className="login-bg-list-link"></Link>
        </div>
        <div className={`login-bg-list-item ${bg6 ? 'active' : ''}`}>
          <Link to="/user/login-v2" onClick={(e) => selectBg(e, 'bg6', '/assets/img/login-bg/login-bg-12.jpg')} style={{ backgroundImage: 'url(/assets/img/login-bg/login-bg-12.jpg)' }} className="login-bg-list-link"></Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
